
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {
    ApplicationActions,
    ApplicationViewModel,
    FilesRequirementValueViewModel,
    FilesRequirementViewModel,
    RequirementFulfillmentViewModel,
    RequirementsClient,
    TempFileModel,
    FileModel
} from "@/api-client";
import Files from "@/components/Files.vue";
import FileUploader from "@/components/FileUploader.vue";
import {ls} from "@/CultureService";
import Loader from "@/features/shared/components/Loader";

@Component({
    components: {
        Files,
        FileUploader
    }
})
export default class FilesRequirement extends Vue {
    public static requirementDescriptionTitle = ls.Applications_Requirements_Files_Title_FileRequirements;

    @Prop({required: true})
    application!: ApplicationViewModel; // TODO: Constrain this.
    @Prop({required: true})
    requirementFulfillment!: RequirementFulfillmentViewModel;
    @Prop({required: true})
    requirement!: FilesRequirementViewModel;
    @Prop({required: true})
    requirementValue!: FilesRequirementValueViewModel | null;
    @Prop({required: true})
    actions!: ApplicationActions;

    chosen: FileModel[] | null = null;
    uploaded: TempFileModel[] = [];

    fileLoader = new Loader();

    async created() {
        if (this.requirementValue) {
            await new RequirementsClient()
                .chosenFiles(this.application.id, this.requirement.id)
                .then(result => this.chosen = result);
        }
    }

    async save() {
        new RequirementsClient().chooseFiles(this.uploaded, this.application.id, this.requirement.id).then(
            () => this.$emit("application-changed"),
            error => this.$emit("error-happened", error));
    }

    async remove(file: FileModel) {
        new RequirementsClient().removeChosenFile(file.id, this.application.id, this.requirement.id).then(
            () => this.$emit("application-changed"),
            error => this.$emit("error-happened", error));
    }

    async getDownloadUrl(fileId: string): Promise<string> {
        return (await new RequirementsClient().downloadFile(fileId, this.application.id, this.requirement.id)).url;
    }

    get showChosen() {
        return this.chosen && this.chosen.length > 0
    }
}
